import React, { useState } from 'react';
import { AgreementWizard } from '../components/AgreementWizard';
import { agreementApi } from '../utils/api';
import { type InstallmentCalculationResult } from '@kist/shared';
import toast from 'react-hot-toast';

export const AgreementWizardPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (formData: any, schedule: InstallmentCalculationResult, signatureData: string | null) => {
    setIsLoading(true);
    
    try {
      // First, create the agreement
      const result = await agreementApi.create({
        ...formData,
        penalty_rule_json: '{"type":"fixed_per_day","amount":1}',
        start_date: new Date(formData.start_date).toISOString(),
      });
      
      // Then, upload the signature if provided
      if (signatureData && result.id) {
        try {
          // Get upload URL for the created agreement
          const uploadResult = await agreementApi.getSignatureUploadUrl(result.id);
          
          // In a real implementation, you would upload the signature data to the provided URL
          // For now, we'll just log that we have the signature data
          console.log('Signature data available for upload:', signatureData.substring(0, 100) + '...');
          console.log('Upload URL received:', uploadResult.uploadUrl);
          
          // Finalize the signature upload
          await agreementApi.finalizeSignature(result.id, {
            signature_data: signatureData,
            upload_url: uploadResult.uploadUrl,
          });
          
          toast.success('Signature uploaded successfully!');
        } catch (uploadError) {
          console.error('Failed to upload signature:', uploadError);
          toast.error('Agreement created but signature upload failed');
        }
      }
      
      toast.success(`Agreement created successfully! ID: ${result.id}`);
      
      // Here you would typically:
      // 1. Navigate to the agreement summary page
      // 2. Show the generated summary HTML
      // 3. Provide sharing options
      
      console.log('Agreement created:', result);
      console.log('Form data:', formData);
      console.log('Schedule:', schedule);
      console.log('Signature data length:', signatureData?.length || 0);
      
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create agreement. Please try again.';
      toast.error(errorMessage);
      console.error('Error creating agreement:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <AgreementWizard onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}; 